import { render } from "./balance_record_list.vue?vue&type=template&id=c83523f2&scoped=true&ts=true"
import script from "./balance_record_list.vue?vue&type=script&lang=ts"
export * from "./balance_record_list.vue?vue&type=script&lang=ts"

import "./balance_record_list.vue?vue&type=style&index=0&id=c83523f2&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83523f2"]])

export default __exports__